import React from 'react';
import { BottomNav } from './BottomNav';

/**
 * Centered mobile-first shell with bottom navigation clearance.
 */
export function BeachvisionLayout({ children }) {
  return (
    <div className="min-h-full bg-beachvision-bg flex justify-center">
      <div className="w-full max-w-beachvision-shell min-h-full flex flex-col pb-24 relative">
        {children}
      </div>
      <BottomNav />
    </div>
  );
}
